import React from "react";
import { AccountsTableRow } from "./AccountsTableRow";
import { HORIZON } from "../../constants/horizon";

const accountSort = (a, b) =>
  b.outstanding_purchase_count - a.outstanding_purchase_count ||
  a.manufacturer.localeCompare(b.manufacturer) ||
  a.network.localeCompare(b.network);

export const AccountsTable = ({ accounts, title, statuses }) => {
  return (
    <div className="mb-4">
      <div className="flex align-items-center mb-2">
        <div className="mr-3 t--500">{title}</div>

        {statuses.length > 0 ? (
          <div className="bg--white border border--rounded px-2 py-1 flex align-items-center gap--8">
            {statuses.map((status) => (
              <div className="flex align-items-center t--md" key={status}>
                <div
                  className={`badge__indicator mr-1 badge__indicator--${HORIZON.STATUS_BADGE_COLOR[status] ?? "red"}`}
                />
                {accounts.filter((acc) => acc.display_status === status).length}
              </div>
            ))}
          </div>
        ) : null}
      </div>
      <div className="mb-4">
        {accounts.length > 0 ? (
          <table className="primary fixed">
            <thead>
              <tr className="sm">
                <th>Manufacturer</th>
                <th>Pharmacy</th>
                <th>Unvalidated Purchases</th>
                <th>Unvalidated WAC</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              {accounts.sort(accountSort).map((account, index) => (
                <AccountsTableRow key={index} account={account} title={title} />
              ))}
            </tbody>
          </table>
        ) : (
          <div className="bg--light-gray flex align-items-center justify-content-center border--rounded t--sm t--secondary w--full h--96">
            No accounts matching this status
          </div>
        )}
      </div>
    </div>
  );
};
